import AnimatedBackground from '../../utils/AnimatedBackground';
import TopBar from '../../utils/TopBar';
import Footer from '../../utils/Footer';

const Goals = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col relative">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <TopBar 
          title="Goals"
          subtitle="Set and track your financial goals"
        />
        <main className="flex-grow flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-semibold text-gray-300 mb-4">Coming Soon</h2>
            <p className="text-gray-400">This feature will be available soon.</p>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Goals;
